import { omit } from 'lodash';
import React from 'react';
import { TBaseTag } from '../CustomTag/types';

const HTMLTag: React.FC<{
  name?: string;
  tagProps: Partial<TBaseTag>;
  children: React.ReactNode;
}> = React.memo(({ name, tagProps, children }) => {
  if (!name || tagProps.excluded) return null;
  return React.createElement(name, omit(tagProps, 'excluded'), children);
});

HTMLTag.displayName = 'HTMLTag';

export default HTMLTag;
